import React, { useState, useEffect } from "react";

import PanelTemplate from "../../templates/Panel";
import DotStatus from "../../components/DotStatus";
import BoxTabs from "../../components/BoxTabs";
import Modal from "../../components/Modal";
import InputSelect from "../../components/InputSelect";
import Input from "../../components/Input";
import InputRadio from "../../components/InputRadio";
import InputEditor from "../../components/InputEditor";
import InputCheckboxes from "../../components/InputCheckboxes";
import PageFooter from "../../components/PageFooter";
import Button from "../../components/Button";
import InputColors from "../../components/InputColors";
import PageHeader from "../../components/PageHeader";
import InputTextarea from "../../components/InputTextarea";
import Table from "../../components/Table";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../services/api";
import { renderError } from "../../helpers/errors";
import { Loading } from "../../components/Loading";
import { createOptions } from "../../helpers/selects";
import states from "../../seeds/states";
import axios from "axios";
import { toast } from "react-toastify";
import { convertIntToMoney, convertMoenyToInt, convertPercentageToFloat, convertPercentageToInt } from "../../helpers/conversions";
import { convertToPercentage } from "../../helpers/masks";
import { ModalDelete } from "../../components/ModalDelete";
import ModalCreateQuote from "../Quote/ModalCreateQuote";
import moment from "moment";
import origins from "../../seeds/origins";
import { hasPermission } from "../../services/auth";
import InputCheckboxUnique from "../../components/InputCheckboxUnique";
import InputFile from "../../components/InputFile";
import { regimeTributarioOptions } from "../../seeds/regimes";

const types = [
    {label: 'Prestador de serviço de gravação', value: 'customization'},
    {label: 'Fornecedor de produto', value: 'product'},
    {label: 'Cliente', value: 'customer'},
    {label: 'Transportadora', value: 'shipping'},
    {label: 'Faturamento', value: 'billing'}
];

const contribuinteICMSOptions = [
    {label: 'Não informado', value: null},
    {label: 'Contribuinte ICMS', value: true},
    {label: 'Não contribuinte', value: false}
];

const QuotesTab = ({quotes}) => {
    const [data, setData] = useState({header: [], rows: []});

    useEffect(() => {
        generateData();
    }, []);

    const generateData = () => {
        const header = ['Código', 'Data da solicitação', 'Status'];
        const rows = [];
        
        quotes.map(quote => {
            rows.push({
                data: [
                    quote.code,
                    moment(quote.created_at).format('DD/MM/YYYY HH:mm'),
                    <>
                        <DotStatus color={quote.status_color} size={15} />
                        {quote.status_name}
                    </>
                ],
                to: `/quote/edit/${quote.id}`
            });
        });

        setData({header, rows});
    }

    return (
        <Table header={data.header} rows={data.rows} />
    );
}

const OrdersTab = ({orders}) => {
    const [data, setData] = useState({header: [], rows: []});

    useEffect(() => {
        generateData();
    }, []);

    const generateData = () => {
        const header = ['Código', 'Data da solicitação'];
        const rows = [];
        
        orders.map(order => {
            rows.push({
                data: [
                    order.code,
                    moment(order.created_at).format('DD/MM/YYYY HH:mm')
                    // <>
                    //     <DotStatus color={order.status_color} size={15} />
                    //     {order.status_name}
                    // </>
                ],
                to: `/order/edit/${order.id}`
            });
        });

        setData({header, rows});
    }

    return (
        <Table header={data.header} rows={data.rows} />
    );
}

const CompanyDetailsTab = ({
    admins, 
    company, 
    type, 
    setType, 
    admin, 
    setAdmin,
    tradeName,
    setTradeName,
    companyName,
    setCompanyName,
    cnpj,
    setCnpj,
    taxPercentage,
    setTaxPercentage,
    zipCode,
    setZipCode,
    street,
    setStreet,
    number,
    setNumber,
    complement,
    setComplement,
    district,
    setDistrict,
    city,
    setCity,
    state,
    setState,
    ie,
    setIe,
    contribuinteICMS,
    setContribuinteICMS,
    regimeTributario,
    setRegimeTributario,
    phone,
    setPhone,
    origin,
    setOrigin,
    canViewPrice,
    setCanViewPrice,
    imageBase64,
    setImageBase64,
    imageName,
    setImageName
}) => {
    return (
        <div>
            <h2 className="section-title">Dados cadastrais</h2>
            <div className="row">
                <div className="col-2">
                    <Input type={`text`} label={`Código`} value={company.code} disabled={true} />
                </div>
                <div className="col-4">
                    <InputSelect label={`Marcadores`} options={types} value={type} change={setType} isMulti={true} />
                </div>
                {type.includes('customer') &&
                    <div className="col-3">
                        <InputSelect label={`Consultor`} options={createOptions(admins, 'name', 'id', true)} value={admin} change={setAdmin} />
                    </div>
                }
                <div className="col-3">
                    <InputSelect label={`Onde nos conheceu`} options={origins} value={origin} change={setOrigin} />
                </div>
            </div>
            <div className="row">
                <div className="col-4">
                    <Input type={`text`} label={`CNPJ`} value={cnpj} change={setCnpj} mask={`convertToCnpj`} />
                </div>
                <div className="col-4">
                    <Input type={`text`} label={`Nome fantasia`} value={tradeName} change={setTradeName} />
                </div>
                <div className="col-4">
                    <Input type={`text`} label={`Razão social`} value={companyName} change={setCompanyName} />
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                    <Input type={`text`} label={`IE`} value={ie} change={setIe} />
                </div>
                <div className="col-3">
                    <InputSelect label={`Regime tributário`} options={regimeTributarioOptions} value={regimeTributario} change={setRegimeTributario} />
                </div>
                <div className="col-3">
                    <InputSelect label={`Contribuinte ICMS`} options={contribuinteICMSOptions} value={contribuinteICMS} change={setContribuinteICMS} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Telefone`} value={phone} change={setPhone} mask={`convertToPhone`} />
                </div>
            </div>
            <InputCheckboxUnique
                label={`Habilitar área exclusiva`}
                checked={canViewPrice} 
                change={setCanViewPrice} 
            />
            {canViewPrice &&
                <div className="row">
                    <div className="col-3">
                        <InputFile 
                            label={`Logo da área exclusiva`} 
                            base64={imageBase64}
                            changeBase64={setImageBase64}
                            name={imageName}
                            changeName={setImageName}
                        />
                    </div>
                </div>
            }
            <h2 className="section-title">Endereço</h2>
            <div className="row">
                <div className="col-3">
                    <Input type={`text`} label={`CEP`} value={zipCode} change={setZipCode} mask={`convertToCep`} />
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <Input type={`text`} label={`Logradouro`} value={street} change={setStreet} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Número`} value={number} change={setNumber} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Complemento`} value={complement} change={setComplement} />
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                    <InputSelect label={`Estado`} options={states} value={state} change={setState} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Cidade`} value={city} change={setCity} />
                </div>
                <div className="col-3">
                    <Input type={`text`} label={`Bairro`} value={district} change={setDistrict} />
                </div>
            </div>
        </div>
    );
}

const TaxTab = ({
    taxPercentage, 
    setTaxPercentage,
    taxPIS,
    setTaxPIS,
    taxCOFINS,
    setTaxCOFINS,
    taxCSLL,
    setTaxCSLL,
    taxIRPJ,
    setTaxIRPJ,
    taxAdicionaisIRPJ,
    setTaxAdicionaisIRPJ
}) => {
    return (
        <>
            <div className="row">
                <div className="col-2">
                    <Input type={`text`} label={`Simples nacional`} value={taxPercentage} change={value => setTaxPercentage( convertToPercentage(value) )} />
                </div>
                <div className="col-2">
                    <Input type={`text`} label={`PIS`} value={taxPIS} change={value => setTaxPIS( convertToPercentage(value) )} />
                </div>
                <div className="col-2">
                    <Input type={`text`} label={`COFINS`} value={taxCOFINS} change={value => setTaxCOFINS( convertToPercentage(value) )} />
                </div>
                <div className="col-2">
                    <Input type={`text`} label={`CSLL`} value={taxCSLL} change={value => setTaxCSLL( convertToPercentage(value) )} />
                </div>
                <div className="col-2">
                    <Input type={`text`} label={`IRPJ`} value={taxIRPJ} change={value => setTaxIRPJ( convertToPercentage(value) )} />
                </div>
                <div className="col-2">
                    <Input type={`text`} label={`Adicionais IRPJ`} value={taxAdicionaisIRPJ} change={value => setTaxAdicionaisIRPJ( convertToPercentage(value) )} />
                </div>
            </div>
        </>
    );
}

const ContactsTab = ({company, getCompany}) => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showCreate, setShowCreate] = useState(false);

    const [customerId, setCustomerId] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');

    const [customerToDelete, setCustomerToDelete] = useState(null);

    useEffect(() => {
        if(!showEdit) clean();
    }, [showEdit]);

    useEffect(() => {
        if(!showCreate) clean();
    }, [showCreate]);

    const updateContact = () => {
        setLoading(true);
        api.put(`/customer/${customerId}`, {
            name,
            phone,
            email
        }).then(res => {
            toast.success('Pessoa atualizada com sucesso');
            getCompany();
            setShowEdit(false);
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const storeContact = () => {
        setLoading(true);
        
        api.post(`/customer`, {
            company_ids: [company.id],
            name,
            phone,
            email,
            type: company.type
        }).then(res => {
            toast.success('Pessoa cadastrada com sucesso');
            getCompany();
            setShowEdit(false);
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const editContact = customer => {
        navigate(`/customer/edit/${customer.id}`);
        // setCustomerId(customer.id);
        // setName(customer.name);
        // setPhone(customer.phone);
        // setEmail(customer.email);
        // setShowEdit(true);
    }

    const clean = () => {
        setCustomerId('');
        setName('');
        setPhone('');
        setEmail('');
    }

    const header = ['Nome', 'E-mail', 'Telefone', 'Empresa'];
    const rows = [];
    company.customers.map(customer => {
        let companies = customer.companies.map(company => company.trade_name).join(', ');
        rows.push({
            data: [customer.name, customer.email, customer.phone, companies],
            action: () => editContact(customer)
        });
    });

    const createContact = () => {
        setShowCreate(true);
    }

    const deleteCustomer = () => {
        setLoading(true);
        api.delete(`/customer/${customerToDelete}`).then(res => {
            setCustomerToDelete(null);
            getCompany();
        }).catch(error => {
            setLoading(false);
            renderError(error);
        });
    }

    return (
        <>
            
            <Modal
                title={`Editar pessoa`}
                show={showEdit}
                close={() => setShowEdit(false)}
                footer={
                    <>
                        <Button 
                            type={`secondary`} 
                            size={`small`}
                            svg={`delete`} 
                            text={`Excluir`} 
                            loading={loading} 
                            action={() => setCustomerToDelete(customerId)}
                        />
                        <Button 
                            type={`primary`}
                            size={`small`}
                            text={`Salvar alterações`}
                            svg={`save-white`}
                            action={updateContact}
                            loading={loading}
                        />
                    </>
                }
            >
                <div className="section">
                     <div className="row">
                        <div className="col-6">
                            <Input type={`text`} label={`Nome`} change={setName} value={name} />
                        </div>
                    </div>   
                    <div className="row">
                        <div className="col-6">
                            <Input type={`email`} label={`E-mail`} change={setEmail} value={email} />
                        </div>
                    </div>   
                    <div className="row">
                        <div className="col-6">
                            <Input type={`text`} label={`Telefone`} change={setPhone} value={phone} mask={`convertToCellphone`} />
                        </div>
                    </div>                 
                </div>
            </Modal>
            <Modal
                title={`Cadastrar pessoa`}
                show={showCreate}
                close={() => setShowCreate(false)}
                footer={
                    <Button 
                        type={`primary`}
                        size={`small`}
                        text={`Cadastrar pessoa`}
                        svg={`save-white`}
                        action={storeContact}
                        loading={loading}
                    />
                }
            >
                <div className="section">
                     <div className="row">
                        <div className="col-6">
                            <Input type={`text`} label={`Nome`} change={setName} value={name} />
                        </div>
                    </div>   
                    <div className="row">
                        <div className="col-6">
                            <Input type={`email`} label={`E-mail`} change={setEmail} value={email} />
                        </div>
                    </div>   
                    <div className="row">
                        <div className="col-6">
                            <Input type={`text`} label={`Telefone`} change={setPhone} value={phone} mask={`convertToCellphone`} />
                        </div>
                    </div>                 
                </div>
            </Modal>
            <ModalDelete 
                show={customerToDelete !== null}
                action={deleteCustomer}
                close={() => setCustomerToDelete(null)}
                loading={loading}
            />
            {hasPermission('create_customer') &&
                <Button type={`secondary`} size={`small`} text={`Adicionar pessoa`} svg={`plus-blue`} action={() => createContact()} />
            }
            <br />
            <Table header={header} rows={rows} loading={loading} />
        </>
    );
}

const PriceTab = ({company, getCompany}) => {
    const [loading, setLoading] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showCreate, setShowCreate] = useState(false);

    const [priceId, setPriceId] = useState('');
    const [sku, setSku] = useState('');
    const [initQtd, setInitQtd] = useState('');
    const [finalQtd, setFinalQtd] = useState('');
    const [price, setPrice] = useState('');

    useEffect(() => {
        if(!showEdit) clean();
    }, [showEdit]);

    useEffect(() => {
        if(!showCreate) clean();
    }, [showCreate]);

    const updatePrice = () => {
        setLoading(true);
        api.put(`/company-price/${priceId}`, {
            company_id: company.id,
            sku,
            init_qtd: initQtd,
            final_qtd: finalQtd,
            price: convertMoenyToInt(price)
        }).then(res => {
            toast.success('Preço atualizado com sucesso');
            getCompany();
            setShowEdit(false);
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const updatePrices = () => {
        setLoading(true);
        api.get(`/sync/${company.id}`).then(res => {
            toast.success('Preços atualizados com sucesso');
            getCompany();
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const storePrice = () => {
        setLoading(true);
        api.post(`/company-price`, {
            company_id: company.id,
            sku,
            init_qtd: initQtd,
            final_qtd: finalQtd,
            price: convertMoenyToInt(price)
        }).then(res => {
            toast.success('Preço cadastrado com sucesso');
            getCompany();
            setShowEdit(false);
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const editPrice = price => {
        setShowEdit(true);
        setPriceId(price.id);
        setSku(price.sku);
        setInitQtd(price.init_qtd);
        setFinalQtd(price.final_qtd);
        setPrice( `R$ ${convertIntToMoney(price.price)}` );
    }

    const clean = () => {
        setPriceId('');
        setSku('');
        setInitQtd('');
        setFinalQtd('');
        setPrice('');
    }

    const header = ['SKU', 'Estoque', 'Quant. inicial', 'Quant. final', 'Preço'];
    const rows = [];

    company.prices.map(price => {
        rows.push({
            data: [price.sku, price.stock, price.init_qtd, price.final_qtd, `R$${price.formatted_price}` ],
            action: () => editPrice(price)
        });
    });

    const createPrice = () => {
        setShowCreate(true);
    }

    return (
        <>
            {company.type.includes('product') &&
                <>
                    <Modal
                        title={`Editar preço`}
                        show={showEdit}
                        close={() => setShowEdit(false)}
                        footer={
                            <>
                                {hasPermission('edit_company_table_price') &&
                                    <Button 
                                    type={`primary`}
                                    size={`small`}
                                    text={`Salvar alterações`}
                                    svg={`save-white`}
                                    action={updatePrice}
                                    loading={loading}
                                    />
                                }
                            </>
                        }
                    >
                        <div className="section">
                            <div className="row">
                                <div className="col-6">
                                    <Input type={`text`} label={`SKU`} change={setSku} value={sku} />
                                </div>
                            </div>   
                            <div className="row">
                                <div className="col-6">
                                    <Input type={`text`} label={`Quant. inicial`} change={setInitQtd} value={initQtd} />
                                </div>
                            </div>   
                            <div className="row">
                                <div className="col-6">
                                    <Input type={`text`} label={`Quant. final`} change={setFinalQtd} value={finalQtd} />
                                </div>
                            </div>   
                            <div className="row">
                                <div className="col-6">
                                    <Input type={`text`} label={`Preço`} change={setPrice} value={price} mask={`convertToMoney`} />
                                </div>
                            </div>               
                        </div>
                    </Modal>
                    <Modal
                        title={`Cadastrar preço`}
                        show={showCreate}
                        close={() => setShowCreate(false)}
                        footer={
                            <Button 
                                type={`primary`}
                                size={`small`}
                                text={`Cadastrar preço`}
                                svg={`save-white`}
                                action={storePrice}
                                loading={loading}
                            />
                        }
                    >
                        <div className="section">
                            <div className="row">
                                <div className="col-6">
                                    <Input type={`text`} label={`SKU`} change={setSku} value={sku} />
                                </div>
                            </div>   
                            <div className="row">
                                <div className="col-6">
                                    <Input type={`text`} label={`Quant. inicial`} change={setInitQtd} value={initQtd} />
                                </div>
                            </div>   
                            <div className="row">
                                <div className="col-6">
                                    <Input type={`text`} label={`Quant. final`} change={setFinalQtd} value={finalQtd} />
                                </div>
                            </div>   
                            <div className="row">
                                <div className="col-6">
                                    <Input type={`text`} label={`Preço`} change={setPrice} value={price} mask={`convertToMoney`} />
                                </div>
                            </div>                  
                        </div>
                    </Modal>
                    <PageHeader
                        left={
                            <>
                                {hasPermission('edit_company_table_price') && ['xbz', 'asiaimports'].includes(company.company_integration) &&
                                    <Button loading={loading} type={`primary`} size={`small`} text={`Buscar atualizações`} action={() => updatePrices()} />
                                }
                                {hasPermission('edit_company_table_price') &&
                                    <Button loading={loading} type={`secondary`} size={`small`} text={`Adicionar preço`} svg={`plus-blue`} action={() => createPrice()} />
                                }
                            </>
                        }
                    />
                    <br />
                    <Table header={header} rows={rows} loading={loading} />
                </>
            }
            {!company.type.includes('product') &&
                <p>Essa aba está disponível apenas para empresa com o marcador "Fornecedor de produto".</p>
            }
        </>
    );
}


export const CompanyEdit = () => {
    const { id } = useParams();
    const navigete = useNavigate();

    const [admins, setAdmins] = useState([]);
    const [tabs, setTabs] = useState([]);

    const [loading, setLoading] = useState(true);
    const [company, setCompany] = useState(null);
    const [tradeName, setTradeName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [cnpj, setCnpj] = useState("");

    const [canViewPrice, setCanViewPrice] = useState(false);

    const [phone, setPhone] = useState("");
    const [ie, setIe] = useState("");
    const [contribuinteICMS, setContribuinteICMS] = useState(null);
    const [regimeTributario, setRegimeTributario] = useState(null);

    const [taxPercentage, setTaxPercentage] = useState('0,0000 %');

    const [taxPIS, setTaxPIS] = useState('0,0000 %');
    const [taxCOFINS, setTaxCOFINS] = useState('0,0000 %');
    const [taxCSLL, setTaxCSLL] = useState('0,0000 %');
    const [taxIRPJ, setTaxIRPJ] = useState('0,0000 %');
    const [taxAdicionaisIRPJ, setTaxAdicionaisIRPJ] = useState('0,0000 %');

    const [zipCode, setZipCode] = useState("");
    const [street, setStreet] = useState("");
    const [number, setNumber] = useState("");
    const [complement, setComplement] = useState("");
    const [district, setDistrict] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");

    const [origin, setOrigin] = useState("");

    const [type, setType] = useState([]);
    const [admin, setAdmin] = useState(null);

    const [confirmDelete, setConfirmDelete] = useState(false);

    const [showCreateQuote, setShowCreateQuote] = useState(false);

    const [imageBase64, setImageBase64] = useState('');
    const [imageName, setImageName] = useState('');

    useEffect(() => {
        getAdmins();
        getCompany();
    }, []);

    useEffect(() => {
        getAddress();
    }, [zipCode]);

    const deleteCompany = () => {
        setLoading(true);

        api.delete(`/company/${id}`).then(res => {
            navigete(`/company/list`);
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const getAddress = () => {
        let convertedZipCode = zipCode.replace('-', '');
        if(convertedZipCode.length === 8){
            if(zipCode !== company.zip_code){
                axios.get(`https://viacep.com.br/ws/${convertedZipCode}/json/`).then(res => {
                    let address = res.data;
                    setStreet(address.logradouro);
                    setDistrict(address.bairro);
                    setCity(address.localidade);
                    setState(address.uf);
                })
            } else {
                setStreet(company.street);
                setDistrict(company.district);
                setCity(company.city);
                setState(company.state);
            }
        }
    }

    const getAdmins = () => {
        api.get(`/list`).then(res => {
            setAdmins(res.data.resources);
        });
    }

    const getCompany = () => {
        setLoading(true);

        api.get(`/company/${id}`).then(res => {
            const resource = res.data.resource;

            setCompany(resource);
            setAdmin(resource.admin_id);
            setType(resource.type);
            let toTabs = [];

            toTabs.push('Detalhes da empresa');

            if(resource.type.includes('billing')){
                toTabs.push('Taxas e impostos');
            }

            toTabs.push('Pessoas');
            toTabs.push('Orçamentos');
            toTabs.push('Pedidos');
            toTabs.push('Prazos de pagamento');
            toTabs.push('Métodos de pagamento');

            if(resource.type.includes('product')){
                toTabs.push('Tabela de preços');
            }
            

            setTabs(toTabs);

            setPhone(resource.phone);
            setIe(resource.ie);
            setContribuinteICMS(resource.contribuinte_icms ?? null);
            setRegimeTributario(resource.regime_tributario ?? null);

            setTaxPercentage( convertToPercentage(resource.tax_percentage ? resource.tax_percentage.toString() : '0') );
            setTaxPIS( convertToPercentage(resource.tax_pis ? resource.tax_pis.toString() : '0') );
            setTaxCOFINS( convertToPercentage(resource.tax_cofins ? resource.tax_cofins.toString() : '0') );
            setTaxCSLL( convertToPercentage(resource.tax_csll ? resource.tax_csll.toString() : '0') );
            setTaxIRPJ( convertToPercentage(resource.tax_irpj ? resource.tax_irpj.toString() : '0') );
            setTaxAdicionaisIRPJ( convertToPercentage(resource.tax_adicionais_irpj ? resource.tax_adicionais_irpj.toString() : '0') );
            
            setCanViewPrice(resource.can_view_price);
            setImageBase64('');
            setImageName(resource?.image_url?.small ?? '');

            setTradeName(resource.trade_name ?? '');
            setCompanyName(resource.company_name ?? '');
            setCnpj(resource.cnpj ?? '');
            setZipCode(resource.zip_code ?? '');
            setStreet(resource.street ?? '');
            setNumber(resource.number ?? '');
            setComplement(resource.complement ?? '');
            setDistrict(resource.district ?? '');
            setCity(resource.city ?? '');
            setState(resource.state ?? '');

            setOrigin(resource.origin ?? '');

        }).catch(error => {
            console.log(error)
            renderError(error);
        }).then(() => setLoading(false));
    }

    const updateCompany = () => {
        setLoading(true);
        api.put(`/company/${company.id}`, {
            ie,
            contribuinte_icms: contribuinteICMS,
            regime_tributario: regimeTributario,
            phone,
            trade_name: tradeName,
            company_name: companyName,
            cnpj,
            type: type,
            tax_percentage: convertPercentageToInt(taxPercentage),
            tax_pis: convertPercentageToInt(taxPIS),
            tax_cofins: convertPercentageToInt(taxCOFINS),
            tax_csll: convertPercentageToInt(taxCSLL),
            tax_irpj: convertPercentageToInt(taxIRPJ),
            tax_adicionais_irpj: convertPercentageToInt(taxAdicionaisIRPJ),
            can_view_price: canViewPrice,
            image: imageBase64,
            zip_code: zipCode,
            street,
            admin_id: type.includes('customer') ? admin : null,
            number,
            district,
            city,
            state,
            complement,
            origin
        }).then(res => {
            getCompany();
            toast.success('Empresa atualizada com sucesso');
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const finishCreation = () => {
        navigete(`/quote/list`);
    }

    const getTabComponents = () => {
        let components = [];

        components.push(
            <CompanyDetailsTab
                company={company}
                type={type}
                setType={setType}
                admins={admins}
                admin={admin}
                setAdmin={setAdmin}
                tradeName={tradeName}
                setTradeName={setTradeName}
                companyName={companyName}
                setCompanyName={setCompanyName}
                cnpj={cnpj}
                setCnpj={setCnpj}
                taxPercentage={taxPercentage}
                setTaxPercentage={setTaxPercentage}
                zipCode={zipCode}
                setZipCode={setZipCode}
                street={street}
                setStreet={setStreet}
                number={number}
                setNumber={setNumber}
                complement={complement}
                setComplement={setComplement}
                district={district}
                setDistrict={setDistrict}
                city={city}
                setCity={setCity}
                state={state}
                setState={setState}
                ie={ie}
                contribuinteICMS={contribuinteICMS}
                setContribuinteICMS={setContribuinteICMS}
                regimeTributario={regimeTributario}
                setRegimeTributario={setRegimeTributario}
                setIe={setIe}
                phone={phone}
                setPhone={setPhone}
                origin={origin}
                setOrigin={setOrigin}
                canViewPrice={canViewPrice}
                setCanViewPrice={setCanViewPrice}
                imageBase64={imageBase64}
                setImageBase64={setImageBase64}
                imageName={imageName}
                setImageName={setImageName}
            />
        );
        if(company.type.includes('billing')){
            components.push(
                <TaxTab
                    taxPercentage={taxPercentage}
                    setTaxPercentage={setTaxPercentage}
                    taxPIS={taxPIS}
                    setTaxPIS={setTaxPIS}
                    taxCOFINS={taxCOFINS}
                    setTaxCOFINS={setTaxCOFINS}
                    taxCSLL={taxCSLL}
                    setTaxCSLL={setTaxCSLL}
                    taxIRPJ={taxIRPJ}
                    setTaxIRPJ={setTaxIRPJ}
                    taxAdicionaisIRPJ={taxAdicionaisIRPJ}
                    setTaxAdicionaisIRPJ={setTaxAdicionaisIRPJ}
                />
            );
        }
        components.push(
            <ContactsTab
                company={company}
                getCompany={getCompany}
            />
        );
        components.push(
            <QuotesTab
                quotes={company.budgets}
            />
        );
        components.push(
            <OrdersTab
                orders={company.orders}
            />
        );
        if(company.type.includes('product')){
            components.push(
                <PriceTab
                    company={company}
                    getCompany={getCompany}
                />
            );
        }

        return components;
    }

    return (
        <>
            <ModalDelete
                show={confirmDelete}
                action={deleteCompany}
                close={() => setConfirmDelete(false)}
                loading={loading}
            />
            {showCreateQuote &&
                <ModalCreateQuote
                    close={() => setShowCreateQuote(false)}
                    finishCreation={finishCreation}
                    customerCompanyId={id}
                />
            }
            <PanelTemplate id="product-edit">
                <Loading show={loading} />
                {!loading &&
                    <BoxTabs
                        titles={tabs}
                        contents={getTabComponents()}
                    />
                }
                <PageFooter spaceBetween={true}>
                    <>
                        <div>
                            {hasPermission('edit_company') &&
                                <Button type={`primary`} size={`small`} svg={`save-white`} text={`Salvar alterações`} action={updateCompany} />
                            }
                            {/* {hasPermission('create_budget') &&
                                <Button type={`secondary`} size={`small`} text={`Criar orçamento`} action={() => setShowCreateQuote(true)} />
                            } */}
                        </div>
                        {hasPermission('delete_company') &&
                            <Button type={`secondary`} size={`small`} svg={`delete-small`} text={`Excluir`} action={() => setConfirmDelete(true)} />
                        }
                    </>
                </PageFooter>
            </PanelTemplate>
        </>
    );
}

export default CompanyEdit;